export default __webpack_public_path__ + "static/media/saas2-slider.6c78c45a.png";